export class FolderBreadcrumb
{
    Id!: number;
    Name!: string;

    constructor(json?: any)
    {
        if (json)
        {
            Object.assign(this, json);
        }
    }
}
